// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { CarePlanTemplateResponse } from './care-plan-template-response';

/** See com.rev360.pms.api.controller.practice.PracticeDiagnosisResponse */
/* istanbul ignore next */
@GandalfModel
export class PracticeDiagnosisResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Boolean })
	active!: boolean | null;

	@GandalfProperty({ designType: CarePlanTemplateResponse })
	carePlanTemplate!: CarePlanTemplateResponse | null;

	@GandalfProperty({ designType: String })
	code!: string | null;

	@GandalfConstantDecorator(constants.CodeSet)
	@GandalfProperty({ designType: constants.CodeSet })
	codeSet!: constants.CodeSet | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	disabledDate!: Date | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: String })
	longDescription!: string | null;

	@GandalfProperty({ designType: Number })
	masterCodeSetId!: number | null;

	@GandalfProperty({ designType: String })
	shortDescription!: string | null;

	@GandalfConstantDecorator(constants.PracticeDiagnosisStatus)
	@GandalfProperty({ designType: constants.PracticeDiagnosisStatus })
	status!: constants.PracticeDiagnosisStatus | null;

}
